export const imgUrl = 'http://122.112.235.243:9999/'
export const baseUrl = 'http://122.112.235.243:8510/'
export const baseUrlRela = 'http://122.112.235.243:8509/'
export const baseUrlQA = 'http://122.112.235.243:1108/'
export const testBaseUrl = 'http://122.112.235.243:8510'
export const baseUrlWB = 'http://service.weibo.com/share/share.php?' // 微博分享地址
export const baseUrlQQ = 'https://sns.qzone.qq.com/cgi-bin/qzshare/cgi_qzshare_onekey?' // QQ分享地址
export const baseUrlView = 'http://122.112.235.243:8282/iiif/2' // 图片查看插件
